import React from 'react';
import { connect } from 'react-redux';
import { Table, Radio } from 'antd';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { toTimezone } from 'utils/dateTimeUtils';
import { Panel } from 'components/ui/index';
import Enums from 'utils/EnumsManager';
import { setSelectedAccountId } from '../flow/action';

const propTypes = {
  theme: PropTypes.string.isRequired,
  metaData: PropTypes.array.isRequired,
  details: PropTypes.array.isRequired,
};

const { FieldTypes } = Enums;
const {
  DateOnly,
  DateTime,
  Email,
  LongText,
  Lookup,
  NumberInput,
  PickList,
  TextInput,
} = FieldTypes;

class SearchResults extends React.Component {
  handleValueChange = e => {
    const { setSelectedAccountId } = this.props;
    setSelectedAccountId(e.target.value);
  }

  renderColumnsByType = meta => {
    const {
      type,
      label,
      name,
      theme
    } = meta;
    const extraConfigs = {};
    const config = {
      title: label,
      dataIndex: name,
    };
    switch (type) {
      case DateOnly:
      case DateTime:
        extraConfigs.render = text => toTimezone(text, type === DateTime);
        break;
      case Lookup:
        extraConfigs.render = text => text && text[meta.lookupKey] ? text[meta.lookupKey] : '';
        break;
      case PickList:
      case Email:
      case LongText:
      case NumberInput:
      case TextInput:
        extraConfigs.render = (text, record) => {
          return name === 'name' || name === 'email' ? <span className={`${theme}-theme-text`}>{text}</span> : text;
        };
        break;
      default:
        return null;
    }
    return {
      ...extraConfigs,
      ...config,
    };
  };

  renderColumns = () => {
    const { metaData, selectedAccountId } = this.props;
    const columns = metaData.map(meta => this.renderColumnsByType(meta));
    columns.unshift({
      title: '',
      key: 'action',
      width: 100,
      className: 'text-center',
      render: (text, record) => (
        <Radio
          value={record.id}
          checked={record.id === selectedAccountId}
          onChange={this.handleValueChange}
        />
      )
    });
    return columns;
  }

  render() {
    const { theme, metaData, details } = this.props;
    return (
      <React.Fragment>
        {_.isArray(metaData) && !_.isEmpty(metaData) &&
          <Panel
            panelClasses={classNames('mt-md', `${theme}-theme-panel`)}
            panelTitle={<FormattedMessage id="page.AttachAccount.searchAccount" />}
          >
            <Table
              columns={this.renderColumns()}
              dataSource={details}
              pagination={false}
              rowKey="id"
            />
          </Panel>
        }
      </React.Fragment>
    );
  }
}

SearchResults.propTypes = propTypes;

const mapStateToProps = ({ global, clientDetails }) => ({
  lang: global.language,
  metaData: clientDetails.attachAccount.searchResults.metaData,
  details: clientDetails.attachAccount.searchResults.details,
  selectedAccountId: clientDetails.attachAccount.selectedAccountId,
});

const mapDispatchToProps = {
  setSelectedAccountId
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);



// WEBPACK FOOTER //
// ./src/views/AttachAccount/components/SearchResults.jsx